import React, { Component } from 'react'
import classnames from 'classnames'
import Sidebar from "../Sidebar/Sidebar";
import {Row} from "../Layout/";
import Column from "../Layout/Column";

const defaultButton = props => (
	<button type="button" {...props} className="-btn">
		{props.children}
	</button>
);


//Duplicated from: https://github.com/tannerlinsley/react-table/blob/v6/src/pagination.js
export default class MagicoPaginationComponent extends Component {
	static defaultProps = {
		PreviousComponent: defaultButton,
		NextComponent: defaultButton,
		renderPageJump: ({
			                 onChange, value, onBlur, onKeyPress, inputType, pageJumpText,
		                 }) => (
			<div className="-pageJump">
				<input
					aria-label={pageJumpText}
					type={inputType}
					onChange={onChange}
					value={value}
					onBlur={onBlur}
					onKeyPress={onKeyPress}
				/>
			</div>
		),
		renderCurrentPage: page => <span className="-currentPage">{page + 1}</span>,
		renderTotalPagesCount: pages => <span className="-totalPages">{pages || 1}</span>,
		renderPageSizeOptions: ({
			                        pageSize,
			                        pageSizeOptions,
			                        rowsSelectorText,
			                        onPageSizeChange,
			                        rowsText,
		                        }) => (
			<span className="select-wrap -pageSizeOptions">
        <select
	        aria-label={rowsSelectorText}
	        onChange={e => onPageSizeChange(Number(e.target.value))}
	        value={pageSize}
        >
          {pageSizeOptions.map((option, i) => (
	          // eslint-disable-next-line react/no-array-index-key
	          <option key={i} value={option}>
		          {`${option} ${rowsText}`}
	          </option>
          ))}
        </select>
      </span>
		),
	}

	constructor (props) {
		super(props)

		this.getSafePage = this.getSafePage.bind(this)
		this.changePage = this.changePage.bind(this)
		this.applyPage = this.applyPage.bind(this)

		this.state = {
			page: props.page,
		}
	}

	componentWillReceiveProps (nextProps) {
		if (this.props.page !== nextProps.page) {
			this.setState({ page: nextProps.page })
		}
	}

	getSafePage (page) {
		if (Number.isNaN(page)) {
			page = this.props.page
		}
		return Math.min(Math.max(page, 0), this.props.pages - 1)
	}

	changePage (page) {
		page = this.getSafePage(page)
		this.setState({ page })
		if (this.props.page !== page) {
			this.props.onPageChange(page)
		}
	}

	applyPage (e) {
		if (e) {
			e.preventDefault()
		}
		const page = this.state.page
		this.changePage(page === '' ? this.props.page : page)
	}

	getPageJumpProperties () {
		return {
			onKeyPress: e => {
				if (e.which === 13 || e.keyCode === 13) {
					this.applyPage()
				}
			},
			onBlur: this.applyPage,
			value: this.state.page === '' ? '' : this.state.page + 1,
			onChange: e => {
				const val = e.target.value
				const page = val - 1
				if (val === '') {
					return this.setState({ page: val })
				}
				this.setState({ page: this.getSafePage(page) })
			},
			inputType: this.state.page === '' ? 'text' : 'number',
			pageJumpText: this.props.pageJumpText,
		}
	}

	render () {
		const {

			// Computed
			pages,
			// Props
			page,
			showPageSizeOptions,
			pageSizeOptions,
			pageSize,
			showPageJump,
			canPrevious,
			canNext,
			onPageSizeChange,
			className,
			PreviousComponent,
			NextComponent,
			renderPageJump,
			renderCurrentPage,
			renderTotalPagesCount,
			renderPageSizeOptions,
		} = this.props;

		return (
			<Row className={classnames(className, '-pagination')} style={this.props.style}>
				<Column/>
				<Column>
					<Row style={{justifyContent:"center"}}>
						<div className="-previous">
							<div
								onClick={() => {
									if (!canPrevious) return;
									this.changePage(page - 1)
								}}
								style={canPrevious ? {color:"red", cursor:"pointer"} : {color: "black", cursor:"default"}}
							>
								{"<"}
							</div>
						</div>
						<div className="-center">
							<span>|</span>
							{renderCurrentPage(page)}/{renderTotalPagesCount(pages)}
							<span>|</span>
						</div>
						<div className="-next">
							<div
								onClick={() => {
									if (!canNext) return;
									this.changePage(page + 1)
								}}
								style={canNext ? {color:"red", cursor:"pointer"} : {color: "black", cursor:"default"}}
							>
								{">"}
							</div>
						</div>
					</Row>
				</Column>
				<Column>
					<Row style={{justifyContent:"flex-end", alignItems:"center"}}>
						<div style={{fontWeight:"Bold"}}>VISUALIZZA</div>
						{renderPageSizeOptions({
							pageSize,
							rowsSelectorText: this.props.rowsSelectorText,
							pageSizeOptions,
							onPageSizeChange,
							rowsText: this.props.rowsText,
						})}
					</Row>
				</Column>
			</Row>
		)
	}
}